<div class="row mt-4 mb-2" [formGroup]="form">
  <div class="col-6">
    Всего: <b>{{count}}</b>
  </div>
</div>
<div class="material-datatable-wrapper">
  <div class="table-responsive">
    <table class="table">
      <tr>
        @for (el of head; track el) {
          <th [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
            <div [formGroup]="form">
              <div class="row no-gutters align-items-center flex-nowrap" [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                <div class="col table__input">
                  @if (el.input) {
                    <app-material-input
                      [placeholder] = "el.caption"
                      [formControlName] = "el.name"
                      [cssClass]="'mb-0'">
                    </app-material-input>
                  }
                  @if (el.select) {
                    <app-material-select
                      [formControlName]="el.name"
                      [cssClass]="'mb-0'">
                      <option [value]="''">{{el.caption}}</option>
                      @for (opt of el.select; track opt) {
                        <option [value]="opt.id">{{opt.caption}}</option>
                      }
                    </app-material-select>
                  }
                  @if (!el.input && !el.select) {
                    {{el.caption}}
                  }
                </div>
                @if (el.sort) {
                  <div class="col-auto">
                    <a href="javascript:void(0)" (click)="sortChange(el.name)">
                  <i class="icon" [ngClass]="{'icon_new-sort-none': true == !sort[el.name],
                                      'icon_new-sort-down': 'asc' == sort[el.name],
                                      'icon_new-sort-up': 'desc' == sort[el.name]}"></i>
                    </a>
                  </div>
                }
              </div>
            </div>
          </th>
        }
      </tr>
      <!-- // -->
      @for (row of rows; track row; let row_index = $index) {
        <tr>
          <td>
            <a [routerLink]="['/physical/edit', row['physicals_id'], 'common']">{{row['physicals_fio']}}</a>
          </td>
          <td>
            {{row['physicals_create_date']}}
          </td>
          <td>
            {{row['physicals_email']}}
          </td>
          <td>
            {{row['phones_phone']}}
          </td>
          <td>
            {{row['event_date']}}
          </td>
          <td>
            <a href="/calendar/edit/{{row['event_id']}}"
              (click)="goBack.newLink('/calendar/edit/' + row['event_id'], 'event_caption-' + row_index, $event)">
              {{row['event_caption']}}
            </a>
          </td>
          <td>
            @if (row['status'] === true) {
              <p>Обработано</p>
            }
            @if (row['status'] === false) {
              <p>Не обработано</p>
            }
          </td>
          <td>
            @if (row['status'] === false) {
              <a [routerLink]="['/physical/edit', row['physicals_id'], 'common']">Добавить в систему</a>
            }
          </td>
        </tr>
      }
    </table>
  </div>
</div>

<div class="alt-pagination">
  <app-paginator
    [queryParams]="filter_columns"
    [itemsPerPage]="50"
    [itemCount]="count"
    [currentPage]="current_page"
    [baseUrl]="'/transfer-log'">
  </app-paginator>
</div>
